import { InputSkeleton } from '@/_components';
import {
  CardContainer,
  Container,
  ContainerLayout,
  FormLayout,
  LeftSection,
  StickyPageHeaderSkeletonWithButtons,
} from '@/_containers';

export default function Loading() {
  return (
    <ContainerLayout>
      <StickyPageHeaderSkeletonWithButtons numberOfButtons={2} withBreadcrumb />

      <Container>
        <LeftSection>
          <CardContainer>
            <FormLayout>
              <InputSkeleton className="col-span-12 sm:col-span-6" />
              <InputSkeleton className="col-span-12 sm:col-span-6" />
              <InputSkeleton className="col-span-12 sm:col-span-6" />

              <div className="col-span-12 grid grid-cols-12 gap-6">
                <InputSkeleton className="col-span-4" />
                <InputSkeleton className="col-span-4" />
              </div>
            </FormLayout>
          </CardContainer>
        </LeftSection>
      </Container>
    </ContainerLayout>
  );
}
